import React from 'react';
import { trimString } from '../../utils/utils';
import Tooltip from '../reusable/Tooltip';

const Header = ({ course }) => {
    const trimNumber = 30;

    return (
        <div className="bg-white w-full rounded-lg p-4 sm:p-6 md:p-8 flex items-center justify-between">
            <div className="flex flex-col sm:flex-row justify-start items-center w-full h-full space-y-4 sm:space-y-0 sm:space-x-4 md:space-x-8">
                {/* Course Image */}
                <img
                    src={course?.image_url}
                    alt="English Course Logo"
                    className="w-32 h-24 sm:w-32 sm:h-28 md:w-32 md:h-24 rounded-xl"
                />

                {/* Course Title and Description */}
                <div className="flex flex-col sm:flex-row justify-center items-center text-center sm:text-left space-y-2 sm:space-y-0 sm:space-x-4 md:space-x-24">
                    <h1 className="font-anek-odia text-2xl sm:text-3xl md:text-4xl lg:text-[48px] font-[600] text-primary">
                        {trimString(course?.title, trimNumber)}
                    </h1>
                    <Tooltip content={course?.description} key={course?.id} >
                        <p className="text-sm sm:text-base font-[400] md:text-lg text-[#929292]">
                            {trimString(course?.description, 80)}
                        </p>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};

export default Header;